// Reads ad-click attribution from the first-party `br_attribution` cookie that
// the marketing site sets (scoped to `.backresto.com`, so it is readable across
// the marketing, app, and account subdomains). Attached to `user.signed_up` so
// the Trial Start conversion can be forwarded to Google Ads (Offline Conversion
// Import) later, keyed on gclid.

const COOKIE_NAME = 'br_attribution';

const KEYS = [
    'gclid',
    'wbraid',
    'gbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
] as const;

export type Attribution = Partial<Record<(typeof KEYS)[number], string>>;

export const readAttribution = (): Attribution => {
    if (typeof document === 'undefined') return {};
    const match = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${COOKIE_NAME}=`));
    if (!match) return {};
    try {
        const parsed = JSON.parse(
            decodeURIComponent(match.split('=').slice(1).join('='))
        ) as Record<string, unknown>;
        const result: Attribution = {};
        for (const key of KEYS) {
            const value = parsed[key];
            if (typeof value === 'string' && value) result[key] = value;
        }
        return result;
    } catch {
        return {};
    }
};
